import React, { useEffect, useState } from "react";
import {
  createFirm,
  getFirms,
  updateFirm,
} from "../../services/firmApi";

const initialState = {
  name: "",
  tag_line: "",
  address: "",
  city: "",
  state: "",
  country: "",
  pincode: "",
  phone: "",
  email: "",
  website: "",
  gst_number: "",
  pan_number: "",
  logo_url: "",
  bank_name: "",
  bank_account_number: "",
  bank_ifsc: "",
  is_active: true,
};

const FirmPage = () => {
  const [firms, setFirms] = useState([]);
  const [form, setForm] = useState(initialState);
  const [editingId, setEditingId] = useState(null);

  // LOAD FIRMS
  const loadFirms = async () => {
    try {
      const data = await getFirms(); // ✅ FIXED
      setFirms(data); // ✅ FIXED (no res.data.firms)
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadFirms();
  }, []);

  // INPUT CHANGE
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // SUBMIT (CREATE / UPDATE)
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editingId) {
        await updateFirm(editingId, form);
      } else {
        await createFirm(form);
      }

      setForm(initialState);
      setEditingId(null);
      loadFirms(); // refresh list
    } catch (err) {
      console.error(err);
    }
  };

  // EDIT
  const handleEdit = (firm) => {
    setForm(firm);
    setEditingId(firm.id);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Firms</h2>

      {/* FORM */}
      <form onSubmit={handleSubmit} style={{ marginBottom: "30px" }}>
        <input
          name="name"
          placeholder="Firm Name"
          value={form.name}
          onChange={handleChange}
        />

        <input
          name="tag_line"
          placeholder="Tag Line"
          value={form.tag_line}
          onChange={handleChange}
        />

        <input
          name="city"
          placeholder="City"
          value={form.city}
          onChange={handleChange}
        />

        <input
          name="phone"
          placeholder="Phone"
          value={form.phone}
          onChange={handleChange}
        />

        <button type="submit">
          {editingId ? "Update Firm" : "Add Firm"}
        </button>
      </form>

      {/* LIST */}
      <table border="1" cellPadding="10" width="100%">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>City</th>
            <th>Phone</th>
            <th>Active</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {firms.length > 0 ? (
            firms.map((firm) => (
              <tr key={firm.id}>
                <td>{firm.id}</td>
                <td>{firm.name}</td>
                <td>{firm.city}</td>
                <td>{firm.phone}</td>
                <td>{firm.is_active ? "Yes" : "No"}</td>
                <td>
                  <button onClick={() => handleEdit(firm)}>
                    Edit
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" style={{ textAlign: "center" }}>
                No firms found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default FirmPage;